'use strict'

angular.module('webremote.module.ondemand', [])

require('./controller')
require('./wizard/controller')
require('./ondemandRouter.service')
